import React from 'react';
import { Stack, Form } from 'react-bootstrap';
import type { ClinicianOption } from '../../../Table/components/AssignToSomeoneElse/AssignToSomeoneElse';
import AssignToSomeoneElse from '../../../Table/components/AssignToSomeoneElse/AssignToSomeoneElse';
import type { PatientTO } from '../../../../../lib';
import { ActionFormatterComponent } from '../../../Table';
import {
  SystemPermission,
  useModal,
  useTriggerUpdate,
} from '../../../../../context';

import './styles.css';
import { useAssignPatient } from '../../../../hooks';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
interface AssignedToFieldProps {
  assignedTo: any[];
  patient: PatientTO;
  clinicianOptions: ClinicianOption[];
}
const AssignedToField = ({
  assignedTo,
  patient,
  clinicianOptions,
}: AssignedToFieldProps) => {
  const { triggerPatientProfileUpdate } = useTriggerUpdate();
  const { openModal } = useModal();
  const { assignToClinician } = useAssignPatient();

  const { selectedTenancy, clinicianId } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const canAssignToOthers =
    !selectedTenancy?.permissionsSetup ||
    (selectedTenancy?.permissionsSetup &&
      selectedTenancy?.userPermissions &&
      !!(selectedTenancy?.userPermissions)[
        SystemPermission.ASSIGN_PATIENT_TO_OTHER
      ]);

  const onSelectAssignTo = (
    value: string,
    patientAccessToken: string,
    callback: (
      isAssigned: boolean,
      patientAccessToken: string,
      clinicianId?: number,
      triggerUpdate?: () => void,
    ) => Promise<any>,
    clinicianId: number,
    isAssigned: boolean = true,
  ) => {
    if (value === 'assignToSomeoneElse') {
      if (!patient) return;
      openModal({
        content: (
          <AssignToSomeoneElse
            clinicianOptions={clinicianOptions}
            patient={patient}
            isPatientProfile
          />
        ),
      });
    } else if (value === 'assignToMe') {
      return callback(
        isAssigned,
        patientAccessToken,
        clinicianId,
        triggerPatientProfileUpdate,
      );
    }
  };

  return (
    <Stack direction="horizontal" className="d-flex align-items-start gap-2">
      <Form.Label className="fw-bold labelBold mb-auto">Assigned to</Form.Label>
      <div className="d-flex flex-column align-items-start gap-2">
        {assignedTo?.map((clinician) => (
          <div
            key={clinician.clinician_id}
            className="d-flex align-items-center gap-2"
          >
            <span>{`${clinician.first_name} ${clinician.last_name}`}</span>
            {(canAssignToOthers || clinician.clinician_id == clinicianId) && (
              <a
                className="unassign-button hide-in-pdf"
                onClick={() =>
                  onSelectAssignTo(
                    'assignToMe',
                    patient.access_token,
                    assignToClinician,
                    clinician.clinician_id,
                    false,
                  )
                }
              >
                Unassign
              </a>
            )}
          </div>
        ))}
        <ActionFormatterComponent
          patientId={patient.id}
          assignedTo={assignedTo}
          onSelectAssignTo={(value, callback, clinicianId) =>
            onSelectAssignTo(value, patient.access_token, callback, clinicianId)
          }
          hasClinicianOptions={clinicianOptions.length > 0}
          inPatientDetails
        />
      </div>
    </Stack>
  );
};

export default AssignedToField;
